function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "36",
  height: "36",
  rx: "5"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#54585D",
  x: "10",
  y: "12",
  width: "16",
  height: "1",
  rx: ".5"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#54585D",
  x: "12",
  y: "17",
  width: "12",
  height: "1",
  rx: ".5"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#54585D",
  x: "14",
  y: "22",
  width: "8",
  height: "1",
  rx: ".5"
}))));